@let act = activation();
@let labels = act.keynoteLabels;
<div class="hd-planet-mini-card">
  <span class="hd-planet-mini-card__icon" [style.color]="accentColor()">{{ act.icon }}</span>
  <div class="hd-planet-mini-card__head">
    <span class="hd-planet-mini-card__title">
      <span class="hd-planet-mini-card__name" [style.color]="accentColor()">{{ act.planet }}</span>
      <span class="hd-planet-mini-card__gate-line" [style.color]="accentColor()">{{ act.gateLine }}</span>
      @if (act.circuitKeynote) {
        <i [class]="'fas fa-' + act.circuitIcon + ' hd-planet-mini-card__circuit-icon'"
           [title]="act.circuitKeynote" [attr.aria-label]="act.circuitKeynote"></i>
      }
    </span>
    <!-- Kenmerken van de poort, zoals in de kop van de gate-info. -->
    <span class="hd-planet-mini-card__traits">
      @for (icon of act.attributeIcons; track icon.key) {
        <hd-gate-attribute-icon [gate]="act.gate" [iconKey]="icon.key" [label]="icon.label"
                                [clickable]="iconsClickable()" />
      }
      <hd-gate-locks-keys-icon [gate]="act.gate" [clickable]="iconsClickable()" />
      <span class="hd-planet-mini-card__center" role="img" data-test-id="planet-mini-card-center"
            [title]="act.center.tooltip" [attr.aria-label]="act.center.tooltip" [innerHTML]="act.center.iconHtml"></span>
    </span>
  </div>
  <dl class="hd-planet-mini-card__keynotes">
    @if (act.planetKeynote) {
      <div class="hd-planet-mini-card__keynote-row" data-keynote="planet">
        <dt class="hd-planet-mini-card__label" [title]="labels.planetTooltip">{{ labels.planet }}</dt>
        <dd class="hd-planet-mini-card__value">{{ act.planetKeynote }}</dd>
      </div>
    }
    <div class="hd-planet-mini-card__keynote-row" data-keynote="gate">
      <dt class="hd-planet-mini-card__label" [title]="labels.gateTooltip">{{ labels.gate }}</dt>
      <!-- Tekst direct na <dd>: een leidende spatie zou in de smalle (inline) weergave meetellen. -->
      <dd class="hd-planet-mini-card__value">{{ act.firstKeynote }}@if (act.secondKeynote) {<span
        class="hd-planet-mini-card__keynote-sep">&nbsp;· </span>{{ act.secondKeynote }}}</dd>
    </div>
    <div class="hd-planet-mini-card__keynote-row" data-keynote="line">
      <dt class="hd-planet-mini-card__label" [title]="labels.lineTooltip">{{ labels.line }}</dt>
      <dd class="hd-planet-mini-card__value">
        <span class="hd-planet-mini-card__line-number">{{ act.lineNumber }}</span>{{ act.lineKeynote }}
      </dd>
    </div>
  </dl>
</div>
